import * as actionTypes from "./constants";

const fetchexpense = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_EXPENSE_ACTION,
      params: params,
    });
  };
};

const approveexpense = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.APPROVE_EXPENSE_ACTION,
      data: data,
    });
  };
};

const rejectexpense = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.REJECT_EXPENSE_ACTION,
      data: data,
    });
  };
};

const fetchExpenseHeadInExpense = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_EXPENSE_HEAD_IN_EXPENSE_ACTION,
    });
  };
};

export default {
  fetchexpense,
  approveexpense,
  rejectexpense,
  fetchExpenseHeadInExpense,
};
